import React from 'react'
import PropTypes from 'prop-types'
import { useEffect } from 'react'

const Wrapper = props => {
  useEffect(() => {
    function handleKeyPress(e) {
      // Close on escape
      if (e.keyCode === 27) {
        props.onCloseModal()
      }
    }

    document.addEventListener('keydown', handleKeyPress)
    return () => {
      document.removeEventListener('keydown', handleKeyPress)
    }
    // eslint-disable-next-line
  }, [])

  if (!props.isOpen) {
    return null
  }

  const fullScreenClass = props.fullScreen ? 'full-screen' : ''

  return (
    <div className={`custom-modal ${fullScreenClass}`}>
      <div className={`modal-wrapper ${props.className || ''}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modal-title">{props.title}</span>
          <div className="modal-header-controls">
            <div className="close" onClick={props.onCloseModal} />
          </div>
        </div>
        <div className="container-wrapper">{props.children}</div>
      </div>
    </div>
  )
}

Wrapper.propTypes = {
  title: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
  isOpen: PropTypes.bool.isRequired,
  fullScreen: PropTypes.bool
}

const Buttons = props => {
  return <div className="modal-buttons-wrapper">{props.children}</div>
}

Buttons.propTypes = {
  children: PropTypes.any.isRequired
}

const Content = props => {
  const fullWidthClass = props.fullWidth ? 'full-width' : ''

  return (
    <div className="content-wrapper">
      <div className={`content ${fullWidthClass}`}>{props.children}</div>
    </div>
  )
}

Content.propTypes = {
  children: PropTypes.any.isRequired,
  fullWidth: PropTypes.bool
}

export default { Buttons, Wrapper, Content }
